module.exports = __webpack_public_path__ + "img/visual_knowledge_base.2cdc2a66.png";